import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../contexts/authContext";
import { AxiosRequestConfig } from "axios";
import Container from "./ProductDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import * as utils from "../../utils";
import api from "../../services/api";
import VariationProductsList from "./Variations/VariationProductsList";
import InfoModal from "../../shared/Bootstrap/InfoModal";
import InputCurrency from "../../components/Buttons/InputCurrency";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { InputImage } from "../../components/InputImage/InputImage";
import PageTitle from "../../components/PageTitle";
import { GetFileFromURL } from "../../utils";
import ReturnButton from "../../components/Buttons/ReturnButton";

export default function ProductDetails(props) {

  const { userData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [categories, setCategories] = useState([{} as any]);
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [categoryId, setCategoryId] = useState(0);
  const [price, setPrice] = useState("R$ 0,00");
  const [description, setDescription] = useState("");
  const [purchaseUrl, setPurchaseUrl] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [variations, setVariations] = useState([] as any);
  const [companyId, setCompanyId] = useState(0);
  const [selectedImageFile, setSelectedImageFile] = useState({} as File);
  const [selectedWebGLBundle, setSelectedWebGLBundle] = useState({} as File);
  const [selectedAndroidBundle, setSelectedAndroidBundle] = useState({} as File);
  const [deleteImage, setDeleteImage] = useState(false);
  const [deleteWebGLBundle, setDeleteWebGLBundle] = useState(false);
  const [deleteAndroidBundleFile, setDeleteAndroidBundleFile] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [variationToDelete, setVariationToDelete] = useState({} as any);
  const [deletingVariation, setDeletingVariation] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const productId = parseInt(props.match?.params?.productId) || 0;
  const creatingNew = productId <= 0;

  useEffect(() => {
    if (!creatingNew)
      LoadProduct();

    LoadCategories();
  }, []);

  async function LoadProduct() {
    try {
      setLoading(true)
      const result = await api.get(`products/${productId}`);
      if (result.data.success) {
        const product = result.data.product;
        SetProduct(product);
      }
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar produto");
    }
    finally {
      setLoadingProduct(false);
    }
  }

  async function LoadCategories() {
    try {
      setLoading(true);
      const result = await api.get(`/productsCategories`);
      if (result.data.success) {
        const categories = result.data.allCategories;
        setCategories(categories);
        if (creatingNew && categories.length > 0)
          setCategoryId(categories[0]?.id);
      }
      else {
        setErrorMessage(result.data.message);
      }
      setLoading(false);
    }
    catch (error: any) {
      setLoading(false);
      setErrorMessage(error?.response?.data?.message);
    }
  }

  function SetProduct(product) {
    try {
      setLoading(true)
      setName(product.name);
      setDisplayName(product.displayName);
      setPrice(utils.CentsToHuman(product.price));
      setDescription(product.description);
      setPurchaseUrl(product.purchaseUrl);
      setIconUrl(product.iconUrl);
      setCompanyId(product.companyId);
      setCategoryId(product.categoryId);
      setVariations(product.variationsGroups);
    }
    catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar o produto");
    } finally {
      setLoading(false);
    }
  }
  async function OnSubmit() {
    try {
      onClosePopup();

      ///TODO: Fazer a validação de um jeito melhor
      if (name.includes("/")) {
        //Alert that / is not permitted
        alert("O nome do produto possui o caractere '/', que não é permitido");

        return;
      }
      const options: AxiosRequestConfig = {};
      const formData = new FormData();
      setLoading(true);
      if (selectedImageFile.name && !deleteImage) {
        formData.append("image", selectedImageFile, selectedImageFile.name);
      }
      if (selectedWebGLBundle.name && !deleteWebGLBundle) {
        formData.append("webGLBundleFile", selectedWebGLBundle, selectedWebGLBundle.name);
      }
      if (selectedAndroidBundle.name && !deleteAndroidBundleFile) {
        formData.append("androidBundleFile", selectedAndroidBundle, selectedAndroidBundle.name);
      }
      if (!creatingNew) {
        formData.append("deleteImage", deleteImage.toString());
        formData.append("deleteWebGLBundle", deleteWebGLBundle.toString());
        formData.append("deleteAndroidBundleFile", deleteAndroidBundleFile.toString());
      }
      if (purchaseUrl) {
        formData.append("purchaseUrl", purchaseUrl);
      }
      formData.append("name", name);
      formData.append("displayName", displayName);
      formData.append("price", utils.CurrencyToCents(price).toString());
      formData.append("description", description);
      formData.append("categoryId", categoryId.toString());
      await (creatingNew ?
        api.post(`/products`, formData, options) :
        api.put(`/products/${productId}`, formData, options));
      if (creatingNew) {
        goBack();
      } else {
        setIconUrl("")
        setShowSuccessPopup(true);
        LoadProduct();
      }
    }
    catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
      setShowSuccessPopup(false);
    } finally {
      setLoading(false);
    }
  }
  function ChangeFileSelected(event) {
    setSelectedImageFile(event.target.files[0]);
    setDeleteImage(false);
  };

  function ChangeWebGLBundleSelected(event) {
    setSelectedWebGLBundle(event.target.files[0]);
    setDeleteWebGLBundle(false);
  }
  function ChangeAndroidBundleSelected(event) {
    setSelectedAndroidBundle(event.target.files[0]);
    setDeleteAndroidBundleFile(false);
  }
  function GetImageUrl(): string {
    return GetFileFromURL(iconUrl, `${process.env.REACT_APP_BASE_URL}/products/${productId}/image`);
  }
  function onOpenPopUp() {
    setShowPopUp(true);
  }
  function onClosePopup() {
    setShowPopUp(false);
  }

  function goBack() {
    props.history.goBack();
  }
  const disabled = loading || (companyId !== userData.companyId && !creatingNew);
  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Produto editado com sucesso!"
        body="Suas edições do produto foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }

  function ShowConfirmDeletion() {
    return (
      <TwoButtonsModal
        show={variationToDelete.id != null}
        onHide={ClosePopupDeletingVariation}
        loading={false}
        title="Deleção de variação!"
        body={`Você está tentando deletar a variação "${variationToDelete.name}", essa ação é irreversível!`}
        secondaryText="Fechar"
        secondaryOnClick={ClosePopupDeletingVariation}
        secondaryDisabled={deletingVariation}
        primaryText="Deletar"
        primaryOnClick={DeleteVariation}
        primaryDisabled={deletingVariation}
      />
    )
  }
  function ClosePopupDeletingVariation() {
    setVariationToDelete({});
  }
  async function DeleteVariation() {
    setDeletingVariation(true);
    try {
      const result = await api.delete(`/products/${productId}/${variationToDelete.id}`);
      if (!result.data.success) {
        setErrorMessage("Não foi possível deletar variação");
      }
      else
        setErrorMessage("");
      await LoadProduct();
    }
    catch (error) {
      setErrorMessage("Não foi possível deletar variação");
    }
    finally {
      setDeletingVariation(false);
      ClosePopupDeletingVariation();
    }
  }
  return (
    <Container className="default-page">
      {ShowSuccessPopup()}
      {ShowConfirmDeletion()}
      <PageTitle title="Detalhes do produto" />
      <TwoButtonsModal
        show={showPopUp}
        onHide={onClosePopup}
        loading={false}
        title={creatingNew ? "Cadastrar produto" : "Editar produto"}
        body={"Você tem certeza que deseja " + (creatingNew ? "Cadastrar este produto?" : "Editar este produto?")}
        secondaryText={"Fechar"}
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText={"Confirmar"}
        primaryOnClick={OnSubmit}
        primaryDisabled={loading}
      />
      <ReturnButton history={props.history} />
      <Spinner spinning={loading || loadingProduct} />
      {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
      <main className="default-main">
        <div className="panel">
          <form className="main-form" onSubmit={(e) => { e.preventDefault(); OnSubmit(); }}>
            <h2>{creatingNew ? "Criar" : "Editar"} Produto</h2>
            <div>
              <label>Nome interno:</label>
              <input
                autoComplete="product-name"
                disabled={disabled || !creatingNew}
                value={name || ""}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div>
              <label>Nome exibido:</label>
              <input
                autoComplete="product-name"
                disabled={disabled}
                value={displayName || ""}
                onChange={e => setDisplayName(e.target.value)}
              />
            </div>

            <div>
              <label>Categoria:</label>
              <select name="category"
                id="category"
                value={categoryId}
                disabled={disabled}
                onChange={e => setCategoryId(parseInt(e.target.value))}>
                {categories.length > 0 && categories[0].id && utils.Sort(categories, c => c.category).map(c =>
                  <option key={c.id} value={c.id}>{c.category}</option>
                )}
              </select>
            </div>
            <div>
              <InputCurrency
                label="Preço:"
                id="price"
                disabled={disabled}
                value={price || ""}
                OnChange={price => setPrice(price)}
              />
            </div>
            <div>
              <label>Descrição:</label>
              <textarea

                autoComplete="product-description"
                disabled={disabled}
                value={description || ""}
                onChange={e => setDescription(e.target.value)}
              />
            </div>

            <div>
              <label>Link para compra:</label>
              <input

                type="text"
                autoComplete="purchase-URL"
                disabled={disabled}
                value={purchaseUrl || ""}
                onChange={e => setPurchaseUrl(e.target.value)}
              />
            </div>
            <div>
              <label>Imagem:</label>
              <InputImage
                id="file"
                label=""
                name="file"
                alt="Imagem do produto"
                acceptedMimeTypes="image/png, image/jpeg"
                imageUrl={GetImageUrl()}
                OnChange={ChangeFileSelected}
                OnRemove={() => setDeleteImage(true)}
                image={selectedImageFile}
              />
            </div>
            <div>
              <label>Asset Bundle WebGL:</label>
              <InputImage
                id="webGLBundle"
                label=""
                name="webGLBundle"
                alt="Imagem do produto"
                acceptedMimeTypes=".assetbundle"
                OnChange={ChangeWebGLBundleSelected}
                OnRemove={() => setDeleteWebGLBundle(true)}
                image={selectedWebGLBundle}
              />
            </div>
            <div>
              <label>Asset Bundle Android:</label>
              <InputImage
                id="androidBundle"
                label="Asset Bundle Android:"
                name="androidBundle"
                alt="Imagem do produto"
                acceptedMimeTypes=".assetbundle"
                OnChange={ChangeAndroidBundleSelected}
                OnRemove={() => setDeleteAndroidBundleFile(true)}
                image={selectedAndroidBundle}
              />
            </div>
            <button
              className="btn btn-success btn-lg mt-4"
              type="button"
              disabled={disabled}
              onClick={e => {
                e.preventDefault();
                onOpenPopUp();
              }}>{creatingNew ?
                "Adicionar produto" :
                "Editar produto"}
            </button>
          </form>
        </div>
        {
          !creatingNew &&
          <VariationProductsList
            productId={productId}
            variations={variations}
            history={props.history}
            disabled={disabled}
            onClickDeleteVariation={variation => setVariationToDelete(variation)}
          />
        }
      </main>
    </Container >
  );
}